module.exports = __webpack_public_path__ + "static/media/agent_man2.3a14aa97.png";